import Swal from 'sweetalert2'

export default function useAlert() {
  const errorAlert = message => {
    Swal.fire({
      title: 'خطا!',
      text: message,
      icon: 'error',
      confirmButtonText: 'باشه',
    })
  }
  const errorUnauthorizedAlert = () => {
    Swal.fire({
      title: 'خطا!',
      text: 'لطفا مجددا وارد سیستم شوید.',
      icon: 'error',
      confirmButtonText: 'باشه',
    })
  }
  const successAlert = message => {
    Swal.fire({
      title: 'انجام شد.',
      text: message,
      icon: 'success',
      confirmButtonText: 'باشه',
    })
  }

  const reloadAlert = message => {
    Swal.fire({
      title: 'برای دریافت آخرین تغییرات لطفا مرورگر خود را رفرش کنید.',
      text: message,
      icon: 'success',
      confirmButtonText: 'باشه',
    }).then(() => {
      window.location.reload()
    })
  }

  const infoAlert = message => {
    Swal.fire({
      text: message,
      icon: 'info',
      confirmButtonText: 'باشه',
    })
  }

  const warningAlert = (title, message) => {
    Swal.fire({
      title,
      text: message,
      icon: 'warning',
      confirmButtonText: 'اوکی مشکلی نیست',
    })
  }

  return {
    errorUnauthorizedAlert,
    errorAlert,
    successAlert,
    infoAlert,
    warningAlert,
    reloadAlert,
  }
}
